import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Calendar from '../../../Part_Sample/Calendar';
import { isEmpty, handleDownloadCSV, makeTimeString, getLocale } from '../../../Common/Common';

import Chart_Bar from '../../../Part_Sample/Chart_Bar_IDU_Hourly';

export default class IDU_Hourly_Chart extends Component {
	constructor(props) {
		super(props);

		const df_options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };

		let tempPid = this.props.param.pid;
		let tempRawData = this.props.param.rawData;

		let workingData = [];

		if (tempRawData.hasOwnProperty(tempPid)) {
			workingData = tempRawData[tempPid];
		}

		let locale = getLocale(this.props.receiver.lang);

		let categoryData = [];
		let coolTotal = [this.props.receiver.getString('cool')];
		let heatTotal = [this.props.receiver.getString('heat')];
		let standbyTotal = [this.props.receiver.getString('standby')];
		let fanTotal = [this.props.receiver.getString('fan')];
		let heaterTotal = [this.props.receiver.getString('heater')];

		workingData.forEach(function (record, index) {
			let timeDateString = record[0].toString();
			let year = parseInt(timeDateString.substring(0, 4));
			let month = parseInt(timeDateString.substring(4, 6)) - 1;
			let day = parseInt(timeDateString.substring(6, 8));
			let hrs = parseInt(timeDateString.substring(8, 10));
			let mins = parseInt(timeDateString.substring(10));

			let timeDate = new Date(year, month, day, hrs, mins, 0, 0);

			if (mins == 0) {
				categoryData.push(timeDate.toLocaleString(locale, df_options));
				coolTotal.push(parseFloat(record[1]));
				heatTotal.push(parseFloat(record[2]));
				standbyTotal.push(parseFloat(record[3]));
				fanTotal.push(parseFloat(record[4]));
				heaterTotal.push(parseFloat(record[5]));
			} else {
				let coolTemp = parseFloat(coolTotal[coolTotal.length - 1] + record[1]);
				let heatTemp = parseFloat(heatTotal[heatTotal.length - 1] + record[2]);
				let standbyTemp = parseFloat(standbyTotal[standbyTotal.length - 1] + record[3]);
				let fanTemp = parseFloat(fanTotal[fanTotal.length - 1] + record[4]);
				let heaterTemp = parseFloat(heaterTotal[heaterTotal.length - 1] + record[5]);

				coolTotal[coolTotal.length - 1] = parseFloat((coolTemp).toFixed(3));
				heatTotal[heatTotal.length - 1] = parseFloat((heatTemp).toFixed(3));
				standbyTotal[standbyTotal.length - 1] = parseFloat((standbyTemp).toFixed(3));
				fanTotal[fanTotal.length - 1] = parseFloat((fanTemp).toFixed(3));
				heaterTotal[heaterTotal.length - 1] = parseFloat((heaterTemp).toFixed(3));
			}
		});

		this.state = {
			chartData: [categoryData, coolTotal, heatTotal, standbyTotal, fanTotal, heaterTotal]
		}

		this.chart = React.createRef();

		window.app.hideLoading();
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('PPD_Data_Analysis', {
			rawData: this.props.param.rawData,
			processedData: this.props.param.processedData,
			chartData: this.props.param.chartData,
			scrollTop: this.props.param.scrollTop,
			fromDate: this.props.param.fromDate,
			toDate: this.props.param.toDate
		});
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			//overflow: 'auto',
		}
		
		let ppd_content_style = {
			overflow: 'auto',
			height: this.props.height - 50,
		}

		let cal_width = this.props.width - 40;
		let cal_height = 200;

		let chart_width = this.props.width - 10;
		//let chart_height = chart_width/3*2;
		let chart_height = 0;

		if (!isEmpty(this.state.chartData)) {
			if (!isEmpty(this.state.chartData[0])) {
				chart_height = this.state.chartData[0].length * 20;
			}
		}

		/*let is_landscape = (this.props.width >= this.props.height)
		if(is_landscape){
			chart_height = this.props.width/3;
			if(chart_height > this.props.height-240 && chart_height>250) chart_height = this.props.height - 240;
		}*/

		let is_show_calendar = false;

		if (this.state.is_show_from_calendar == true || this.state.is_show_to_calendar == true) {
			is_show_calendar = true;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar' ref={this.divRef}>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('ppd_data_analysis')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					
					<div style={ppd_content_style}>
						<div style={{ width: this.props.width - 20, paddingBottom: '10px' }}>
							<span className='title'>{window.app.state.point_list[this.props.param.pid].name}</span>
						</div>

						{isEmpty(this.state.chartData) ? <div></div> : (
							<Chart_Bar
								style={{ zIndex: is_show_calendar ? -1 : 1, paddingBottom: '20px' }}
								id={'IDU_Hourly_Chart'}
								ref={this.chart}
								title={this.props.receiver.getString('IDU_Hourly_Chart') + ' (kWh)'}
								chart_width={chart_width}
								chart_height={chart_height}
								data={this.state.chartData}
								receiver={this.props.receiver}
								handleIDUHourlyChart={this.handleIDUHourlyChart}
							/>
						)}
					</div>
				</div>
			</div>
		)
	}
}